<div class="wrap">
  <h3 appChangeColorTheme attribute="bgc" rgba="0.2">Création/ Modification d'un panier</h3>

  <form class="content_new_booking" [formGroup]="newBookingForm" (ngSubmit)="onSubmit()">

    <div class="infos_user_trainee">
      <div class="infos_user">

        <div class="form_content">
          <ng-container *ngIf="!showResultSearch">
            <mat-form-field appearance="outline">
              <mat-label>
                <fa-icon [icon]="getFaIcon('faUser')" appChangeColorTheme attribute="color"></fa-icon>
                <span>Recherche par utilisateur</span></mat-label>
              <input matInput type="text" [formControl]="myControl" [matAutocomplete]="auto"
                (input)="setValueInput($event.target.value)">
              <button *ngIf="myControl.value" type="button" matSuffix mat-icon-button aria-label="Clear"
                (click)="resetEmail()">
                <fa-icon [icon]="getFaIcon('faTimes')" appChangeColorTheme attribute="color"></fa-icon>
              </button>
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn.bind(this)">
                <mat-option *ngFor="let c of filteredOptions  | async" [value]="c"
                  matTooltip="{{c?.email}} ({{c?.lastName}} {{c?.firstName}})">
                  {{c?.email}} ({{c?.lastName}} {{c?.firstName}})
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

          </ng-container>

          <ng-container *ngIf="customer">
            <mat-form-field appearance="outline">
              <mat-label>Email</mat-label>
              <input matInput type="text" formControlName="email">
            </mat-form-field>

            <div class="infos_user_name">

              <mat-form-field appearance="outline">
                <mat-label>Nom</mat-label>
                <input matInput type="text" formControlName="lastName">
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Prénom</mat-label>
                <input matInput type="text" formControlName="firstName">
              </mat-form-field>

            </div>
          </ng-container>

          <button class="advance_search" type="button" *ngIf="!customer" (click)="searchAdvance()" appChangeColorTheme
            attribute="bgc">
            <fa-icon [icon]="getFaIcon('faSearch')"></fa-icon>
            <span>Autres recherches</span>
            <fa-icon [icon]="getFaIcon('faInfoCircle')" class="infos"
              [matTooltip]="getTooltip('counterInfosSearch')"></fa-icon>
          </button>

          <button class="add_user" type="button" *ngIf="!customer" (click)="openDialogAddEditUser('add')"
            appChangeColorTheme attribute="bgc">
            <fa-icon [icon]="getFaIcon('faUserPlus')"></fa-icon>
            <span>Créer un nouveau client</span>
          </button>
        </div>
      </div>

      <div class="trainees_user" *ngIf="customer?.userKey">
        <div class="sub_title">
          <div class="sub_title_label">
            <fa-icon [icon]="getFaIcon('faUsers')" appChangeColorTheme attribute="color"></fa-icon>
            <h4>Liste des stagiaires (<strong>{{trainees?.length}}</strong>)</h4>

          </div>
          <fa-icon class="faUserPlus" [icon]="getFaIcon('faUserPlus')" (click)="openDialogAddOrEditTrainee('add')"
            appChangeColorTheme attribute="bgc"></fa-icon>
        </div>

        <div class="no_trainees" *ngIf="!trainees?.length">
          <p> Aucun stagiaire </p>
        </div>

        <ngx-simplebar class="trainees_list">
          <div class="trainee_item" *ngFor="let t of trainees">
            <fa-icon [icon]="getFaIcon('faUser')"></fa-icon>
            <p>{{t.traineeFirstName}} {{t.traineeLastName}}</p>
            <div class="trainee_actions">
              <fa-icon [icon]="getFaIcon('faPen')" (click)="openDialogAddOrEditTrainee('edit', t)"></fa-icon>
            </div>
          </div>
        </ngx-simplebar>
      </div>
    </div>

    <div class="booking" [style.opacity]=" customer ?  1 : .5">
      <ng-container *ngIf="!showResultSearch">
        <fa-icon *ngIf="resultSearch?.length > 0" class="arrowToSearch" (click)="showResultSearch = true"
          matTooltip="Retour vers la recherche" [icon]="getFaIcon('faChevronLeft')" appChangeColorTheme
          attribute="color"></fa-icon>
        <div class="sub_title_border">
          <div class="sub_title_tab">
            <div
              [ngClass]="{sub_title_label_inactive: tab !== 'basketInProgress', sub_title_label_active: tab === 'basketInProgress'}"
              (click)="customer? changeTab('basketInProgress') : null">
              <fa-icon [icon]=" basket?.length ? getFaIcon('faShoppingBasket') : getFaIcon('faPlus')"></fa-icon>
              <h4>{{basket?.length ? 'Panier utilisateur en cours' : 'Nouveau panier' }}</h4>
              <!-- <h4>Panier utilisateur en cours</h4> -->
            </div>
            <div [ngClass]="{sub_title_label_inactive: tab !== 'basket', sub_title_label_active: tab === 'basket'}"
              (click)="customer? changeTab('basket') : null">
              <fa-icon [icon]="getFaIcon('faShoppingBasket')"></fa-icon>
              <h4 *ngIf="updateBasketBooked">Paniers validés en cours de modification par le guichet</h4>
              <h4 *ngIf="!updateBasketBooked">Paniers validés ({{this.bookingUser?.length || 0}})</h4>
            </div>

          </div>
          <fa-icon *ngIf="tab === 'basketInProgress'" class="faSearch" [icon]="getFaIcon('faSearch')"
            (click)=" customer? openDialogAddOfferToCounter(): null" appChangeColorTheme attribute="bgc"></fa-icon>

        </div>

        <form class="form_booking" [formGroup]="bookingCustomerForm" *ngIf="tab === 'basket'"
          [style.grid-template-columns]=" updateBasketBooked? '1fr' : '1fr 40px max-content'">
          <ng-container *ngIf="!updateBasketBooked">
            <mat-form-field appearance="outline">
              <mat-label>Paniers validés
              </mat-label>
              <mat-select formControlName="booking" (valueChange)="changeBookingOverview($event)">
                <mat-option *ngFor="let b of bookingUser" [value]="b">
                  {{b.bookingReference}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <fa-icon [icon]="getFaIcon('faFilePdf')" [matTooltip]="getTooltip('downloadBill')"
              (click)="exportPdfBill();" [style.text-align]="'center'" appChangeColorTheme attribute="color"></fa-icon>
            <button type="button" (click)="updateBooking()" appChangeColorTheme attribute="bgc">Modifier le panier
              validé</button>
          </ng-container>
          <button class="canceled" type="button" *ngIf="updateBasketBooked" (click)="updateBooking(true)"
            appChangeColorTheme attribute="bgc">Annuler la modification</button>
        </form>

        <ngx-simplebar class="list_basket_column_content" *ngIf="tab === 'basketInProgress'">
          <div class="card_laptop" *ngFor="let o of  basket, let i = index"
            [style.opacity]="(o.isSelected && tab === 'basketInProgress')   ? 1 : .5">
            <div class="img">
              <app-image-offer [offerKey]="o.offerKey" [width]="100" [height]="'250px'"></app-image-offer>


              <div class="checkbox_and_photo_experience">
                <mat-checkbox [color]="color" [style.opacity]="1"
                  (click)="checkAddToPayment( o) ? addToPayment(o) : $event.preventDefault()" [checked]="o.isSelected">
                </mat-checkbox>
                <div class="photo_experience" *ngIf=" o?.photoExperience ">
                  <p>{{ o?.photoExperience }}</p>
                </div>
              </div>
              <div class="infos_sub_img">
                <div class="infos">
                  <div class="icon">
                    <fa-icon [icon]="getFaIcon('faClockSolid')"></fa-icon>
                  </div>
                  {{o?.duration? o?.duration : 'NC'}}
                </div>
                <div class="infos">
                  <div class="icon">
                    <fa-icon [icon]="getFaIcon('faMapMarkedAlt')"></fa-icon>
                  </div>
                  <p>
                    {{o?.practicePlace? o?.practicePlace: 'NC'}}
                  </p>
                </div>
              </div>

            </div>

            <div class="description_price_action">

              <div class="description">
                <h4>{{o?.offerName}}</h4>
                <p class="offer_description" [innerHTML]="o?.description">
                  <!-- {{ o?.description | textDescription}} -->
                </p>
                <div class="delete_copy_offer" appChangeColorTheme attribute="color">
                  <fa-icon [icon]="getFaIcon('faTrashAlt')" (click)="deleteInMyShoppingBag(o)"></fa-icon>
                </div>
              </div>

              <div class="status_offer_price" *ngIf="o.hasSession">
                <div class="status_offer">
                  <span [ngClass]="{status_of_offer: !o.isComplete, status_of_offer_valid:o.isComplete  }"
                    (click)="!o.isComplete && o.isSelected? opendialogCustomizeMySession(o): null">
                    <fa-icon [icon]="getFaIcon('faCheckCircle')" *ngIf="o.isComplete"></fa-icon>
                    <fa-icon [icon]="getFaIcon('faEdit')" *ngIf="!o.isComplete"></fa-icon>
                    {{o.isComplete? 'Offre personnalisée': 'Personnaliser l\'offre'}}

                  </span>
                  <span class="edit_param_offer" *ngIf="o.isComplete"
                    (click)="o?.isSelected? opendialogCustomizeMySession(o) : getMessageAddOfferToPaiment()"
                    appChangeColorTheme attribute="bgc">
                    <fa-icon [icon]="getFaIcon('faEdit')" [matTooltip]="getTooltip('myShoppingBagPersoOffer')">
                    </fa-icon>
                  </span>

                </div>
                <!-- <div class="price_label">
                  <strong> {{ getStatuPriceOfOffer(o, i)}}</strong>
                </div> -->
              </div>
              <app-manage-quantity [priceWithoutSessions]="getStatuPriceOfOffer(o, i)" [offer]="o" [index]="i"
                [type]="'guichet'" [myShoppingBag]=" basket " [userKeyInAdmin]="customer?.userKey" [isCounter]="false"
                [isBasketInCounter]="true" (updateQuantityValues)="getNewValueOfQuantity($event)"
                (sendSelectedSession)="getNewSelectedSession($event, o)">
              </app-manage-quantity>

            </div>
          </div>

        </ngx-simplebar>

        <ngx-simplebar class="list_basket_column_content" *ngIf="tab === 'basket'">
          <ng-container *ngFor="let o of updateBasketBooked ? offerAddToPayment : sessionBooking, let i = index">

            <ng-container [ngSwitch]="updateBasketBooked">
              <ng-container *ngSwitchCase="true">
                <div class="card_laptop" [style.opacity]="(o.isSelected && tab === 'basket')   ? 1 : .5">
                  <div class="img">
                    <app-image-offer [offerKey]="o.offerKey" [width]="100" [height]="'250px'"></app-image-offer>

                    <div class="checkbox_and_photo_experience">
                      <mat-checkbox [color]="color" [style.opacity]="1"
                        (click)="checkAddToPayment(o) ? addToPayment(o) : $event.preventDefault()"
                        [checked]="o.isSelected">
                      </mat-checkbox>
                      <div class="photo_experience" *ngIf=" o?.photoExperience ">
                        <p>{{ o?.photoExperience }}</p>
                      </div>
                    </div>
                    <div class="infos_sub_img">
                      <div class="infos">
                        <div class="icon">
                          <fa-icon [icon]="getFaIcon('faClockSolid')"></fa-icon>
                        </div>
                        {{o?.duration? o?.duration : 'NC'}}
                      </div>
                      <div class="infos">
                        <div class="icon">
                          <fa-icon [icon]="getFaIcon('faMapMarkedAlt')"></fa-icon>
                        </div>
                        <p>
                          {{o?.practicePlace? o?.practicePlace: 'NC'}}
                        </p>
                      </div>
                    </div>

                  </div>

                  <div class="description_price_action">
                    <div class="description">
                      <h4>{{o?.offerName}}</h4>
                      <p class="offer_description" [innerHTML]="o?.description">
                        <!-- {{ o?.description | textDescription}} -->
                      </p>
                      <!-- <div class="delete_copy_offer" appChangeColorTheme attribute="color">
                        <fa-icon [icon]="getFaIcon('faTrashAlt')" (click)="deleteInMyShoppingBag(o)"></fa-icon>
                      </div> -->
                    </div>

                    <div class="status_offer_price" *ngIf="o.hasSession">
                      <div class="status_offer">
                        <span [ngClass]="{status_of_offer: !o.isComplete, status_of_offer_valid:o.isComplete  }"
                          (click)="!o.isComplete && o.isSelected? opendialogCustomizeMySession(o): null">
                          <fa-icon [icon]="getFaIcon('faCheckCircle')" *ngIf="o.isComplete"></fa-icon>
                          <fa-icon [icon]="getFaIcon('faEdit')" *ngIf="!o.isComplete"></fa-icon>
                          {{o.isComplete? 'Offre personnalisée': 'Personnaliser l\'offre'}}

                        </span>
                        <span class="edit_param_offer" *ngIf="o.isComplete"
                          (click)="o?.isSelected? opendialogCustomizeMySession(o) : getMessageAddOfferToPaiment()"
                          appChangeColorTheme attribute="bgc">
                          <fa-icon [icon]="getFaIcon('faEdit')" [matTooltip]="getTooltip('myShoppingBagPersoOffer')">
                          </fa-icon>
                        </span>

                      </div>
                      <!-- <div class="price_label">
                      <strong>{{ getStatuPriceOfOffer(o, i)}}</strong>
                    </div> -->
                    </div>
                    <app-manage-quantity [priceWithoutSessions]="getStatuPriceOfOffer(o, i)" [offer]="o" [index]="i"
                      [type]="'guichet'" [myShoppingBag]="basket " [userKeyInAdmin]="customer?.userKey"
                      [isCounter]="false" [isBasketInCounter]="true"
                      (updateQuantityValues)="getNewValueOfQuantity($event, o?.counterSessionBasketKey)"
                      (getCounterSessionBasketUpdate)="updateSessionBasketPriceByMau()"
                      (sendSelectedSession)="getNewSelectedSession($event, o)">
                    </app-manage-quantity>

                  </div>
                </div>
              </ng-container>
              <ng-container *ngSwitchCase="false">
                <div class="card_laptop" *ngIf="!o.offer.isLicence">
                  <div class="img">
                    <app-image-offer [offerKey]="o?.offer?.offerKey" [width]="100" [height]="'250px'"></app-image-offer>

                    <div class="checkbox_and_photo_experience">

                      <div class="photo_experience" *ngIf="o?.offer.photoExperience">
                        <p>{{o?.offer.photoExperience}}</p>
                      </div>
                    </div>
                    <div class="infos_sub_img">
                      <div class="infos">
                        <div class="icon">
                          <fa-icon [icon]="getFaIcon('faClockSolid')"></fa-icon>
                        </div>
                        {{o?.duration? o?.duration : 'NC'}}
                      </div>
                      <div class="infos">
                        <div class="icon">
                          <fa-icon [icon]="getFaIcon('faMapMarkedAlt')"></fa-icon>
                        </div>
                        <p>
                          {{o?.practicePlace? o?.practicePlace: 'NC'}}
                        </p>
                      </div>
                    </div>

                  </div>

                  <div class="description_price_action">

                    <div class="description">
                      <h4>{{ o?.offer?.offerName}}</h4>
                      <p class="offer_description" [innerHTML]="o?.offer?.description">
                        {{ o?.offer?.description | textDescription}}
                      </p>

                    </div>

                    <div class="price_label" *ngIf="!updateBasketBooked ">
                      <!-- <strong>{{offerAddToPayment[i]?.bookedSessionAmount}}€</strong> -->
                      <strong>{{o.bookedSessionAmount}}€</strong>
                    </div>

                    <ng-container *ngIf="updateBasketBooked">
                      <div class="status_offer_price" *ngIf="o?.offer?.hasSession ">
                        <div class="status_offer">
                          <span
                            [ngClass]="{status_of_offer: sessionBookingCounter[i].traineeQuantity !== sessionBookingCounter[i].trainees?.length, status_of_offer_valid: sessionBookingCounter[i].traineeQuantity === sessionBookingCounter[i].trainees?.length  }"
                            (click)=" sessionBookingCounter[i].traineeQuantity !== sessionBookingCounter[i].trainees?.length ?opendialogCustomizeMySession(sessionBookingCounter[i]) : null">
                            <fa-icon [icon]="getFaIcon('faCheckCircle')"
                              *ngIf="sessionBookingCounter[i].traineeQuantity === sessionBookingCounter[i].trainees?.length">
                            </fa-icon>
                            <fa-icon [icon]="getFaIcon('faEdit')"
                              *ngIf="sessionBookingCounter[i].traineeQuantity !== sessionBookingCounter[i].trainees?.length">
                            </fa-icon>
                            {{sessionBookingCounter[i].traineeQuantity !== sessionBookingCounter[i].trainees?.length?
                            'Offre personnalisée': 'Personnaliser l\'offre'}}

                          </span>
                          <span class="edit_param_offer"
                            (click)="opendialogCustomizeMySession(sessionBookingCounter[i])" appChangeColorTheme
                            attribute="bgc">
                            <fa-icon [icon]="getFaIcon('faEdit')" [matTooltip]="getTooltip('myShoppingBagPersoOffer')">
                            </fa-icon>
                          </span>

                        </div>

                        <!-- <div class="price_label">

                          <strong> {{ getStatuPriceOfOffer(o, i)}}</strong>
                        </div> -->

                      </div>

                    </ng-container>

                  </div>
                </div>
              </ng-container>
            </ng-container>

          </ng-container>
        </ngx-simplebar>
      </ng-container>

      <div class="result_search" *ngIf="showResultSearch">
        <h3>
          Recherche avancée
          <fa-icon [icon]="getFaIcon('faTimes')" (click)="closeSearch()"></fa-icon>
        </h3>

        <form [formGroup]="searchAdvancedForm" (ngSubmit)="submitSearchAdvance()">
          <mat-form-field appearance="outline">
            <mat-label>Recherche</mat-label>
            <input matInput type="text" formControlName="keyword" (input)="setValueInput($event.target.value)">

          </mat-form-field>
          <button type="submit" appChangeColorTheme attribute="bgc">
            <fa-icon [icon]="getFaIcon('faSearch')"></fa-icon>
          </button>
        </form>

        <div class="tabs" [style.grid-template-columns]="'repeat('+tabsSearch?.length+',1fr)'">
          <ng-container *ngFor="let t of tabsSearch">
            <div [ngClass]="{tab_active: tabsSearchActive === t, tab_inactive: tabsSearchActive !== t }"
              (click)="changeTab(t, true)">
              {{getTitleTabSearch(t)}}
            </div>
          </ng-container>
        </div>

        <app-table-search *ngIf="resultSearch?.length" [resultSearch]="resultSearch"
          [tabsSearchActive]="tabsSearchActive" (booking)="setBookingSelected($event)"></app-table-search>

        <p class="no_result" *ngIf="!resultSearch?.length">Aucun résultat pour votre recherche</p>

      </div>
    </div>

    <div class="total_booking" [style.grid-template-rows]="tab === 'basket'? 'repeat(2, 1fr)' : '1fr'">
      <div class="total">
        <!-- <div class="total" *ngIf="tab === 'basketInProgress' || tab === 'basket' && updateBasketBooked "> -->
        <div class="sub_title_basket">
          <fa-icon [icon]="getFaIcon('faShoppingBasket')"></fa-icon>
          <h4>Total du panier (<strong>{{offerAddToPayment?.length || 0}}</strong>)</h4>
        </div>

        <div class="total_booking_content" [style.height]="tab === 'basket' ? '200px' : '100%'">

          <ng-container [ngSwitch]="tab">
            <ng-container *ngIf="offerAddToPayment?.length">
              <ul *ngSwitchCase="'basketInProgress'">

                <ng-container *ngFor="let o of offerAddToPayment">
                  <div class="list_item" [style.opacity]="o?.isSelected  ? 1 : 0">
                    <div class="list_item_offerAddToPayment" *ngIf="o?.isSelected"
                      style="--numbOfItemInBasket:var(--numbOfItemInBasket){{offerAddToPayment?.length}}"
                      [style.grid-template-columns]="o.hasSession ? 'max-content 1fr' : '1fr' ">
                      <mat-checkbox *ngIf="tab !== 'basket'" [checked]="true" [color]="color" (click)="addToPayment(o)">
                      </mat-checkbox>

                      <li class="item_offerAddToPayment">
                        <span class="label">{{o?.offerName}}</span>
                        <span class="price" *ngIf="!o.isComplete"><strong> À perso.</strong></span>
                        <span class="session_price" *ngIf="o.isComplete && !o?.hasSession">
                          <fa-icon [icon]="getFaIcon('faInfoCircle')" appChangeColorTheme attribute="color"
                            *ngIf="o.advancePayment > 0"
                            [matTooltip]="'Il y a un acompte de ' + o.advancePayment + '€'"></fa-icon>
                          <span *ngIf="o?.traineeQuantity">
                            <i style="font-weight: 400;">({{o?.traineeQuantity}} x
                              {{o?.fixedPrice}}€) </i></span>
                          {{o?.sessionTotalPrice}}€</span>
                      </li>
                    </div>

                    <div class="session" *ngIf="o?.isComplete && o?.isSelected && o.hasSession">

                      <span class="session_label" appChangeColorTheme attribute="color">
                        <fa-icon [icon]="getFaIcon('faCalendarAlt')"></fa-icon>
                        <ng-container *ngIf="o.hasSession">
                          {{getSessionOfferBasket(o)?.dateLib}} -
                          {{getSessionOfferBasket(o)?.sessionStartDate | date: "shortDate":'UTC'}}
                        </ng-container>

                      </span>
                      <span class="session_price">
                        <fa-icon [icon]="getFaIcon('faInfoCircle')" appChangeColorTheme attribute="color"
                          *ngIf="o.advancePayment > 0"
                          [matTooltip]="'Il y a un acompte de ' + o.advancePayment + '€'"></fa-icon>
                        <span *ngIf="o?.traineeQuantity">
                          <i style="font-weight: 400;">({{o?.traineeQuantity}} x
                            {{o?.fixedPrice}}€) </i></span>
                        {{o?.sessionTotalPrice}}€</span>
                    </div>
                  </div>
                </ng-container>
                <li *ngIf="!noOfferInBasket().length" class="no_offer_to_perso">Aucune offre sélectionnée </li>

                <div class="add_licence" *ngIf="licences?.length">
                  <div class="licence_title">
                    <h5>Ajout de licence</h5>
                    <span><strong>x{{licences?.length}}</strong></span>
                  </div>


                  <div class="licence_content">
                    <div class="licence_item" *ngFor="let l of licences">
                      <p *ngIf="l?.sessions">{{l?.sessions[0]?.dateLib}}</p>
                      <span>
                        <strong>{{l.sessionTotalPrice}}€</strong></span>
                    </div>
                  </div>
                </div>

                <li class="last_item" *ngIf="basketWithPrice?.grandDiscount > 0"><span class="label">Réduction
                    supplémentaire
                  </span> <span class="price"><strong>{{basketWithPrice?.grandDiscount}}%</strong></span></li>
                <li class="last_item" *ngIf="basketWithPrice?.grandDiscount > 0"><span class="label">Total remisé
                  </span>
                  <span class="price"><strong>{{basketWithPrice?.discountedGrandTotal}}€</strong></span>
                </li>
              </ul>
            </ng-container>
            <ng-container *ngIf="updateBasketBooked ? offerAddToPayment?.length :  sessionBooking?.length">
              <ul *ngSwitchCase="'basket'">

                <ng-container *ngFor="let o of updateBasketBooked ? offerAddToPayment :  sessionBooking">

                  <ng-container [ngSwitch]="updateBasketBooked">
                    <ng-container *ngSwitchCase="true">
                      <div class="list_item">
                        <div class="list_item_offerAddToPayment"
                          style="--numbOfItemInBasket:var(--numbOfItemInBasket){{offerAddToPayment?.length}}"
                          [style.grid-template-columns]="o?.hasSession ? 'max-content 1fr' : '1fr' ">


                          <li class="item_offerAddToPayment">
                            <span class="label">{{o?.offerName}}</span>
                            <!-- <span class="price" *ngIf="!o?.offer?.isComplete"><strong> À perso.</strong></span> -->
                            <span class="session_price" *ngIf="!o?.hasSession">
                              <fa-icon [icon]="getFaIcon('faInfoCircle')" appChangeColorTheme attribute="color"
                                *ngIf="o.advancePayment > 0"
                                [matTooltip]="'Il y a un acompte de ' + o.advancePayment + '€'"></fa-icon>
                              <span *ngIf="o?.traineeQuantity">
                                <i style="font-weight: 400;">({{o?.traineeQuantity}} x
                                  {{o?.fixedPrice}}€) </i></span>
                              {{o?.sessionTotalPrice}}€</span>
                            <!-- <span class="session_price" *ngIf="o?.offer?.isComplete && !o?.offer?.hasSession">{{o?.bookedSessionAmount}}€</span> -->
                          </li>
                        </div>

                        <div class="session" *ngIf="o?.hasSession">

                          <span class="session_label" appChangeColorTheme attribute="color">
                            <fa-icon [icon]="getFaIcon('faCalendarAlt')"></fa-icon>
                            <ng-container *ngIf="o.hasSession">
                              {{getSessionOfferBasket(o)?.dateLib}} -
                              {{getSessionOfferBasket(o)?.sessionStartDate | date: "shortDate":'UTC'}}
                            </ng-container>

                          </span>
                          <span class="session_price">
                            <fa-icon [icon]="getFaIcon('faInfoCircle')" appChangeColorTheme attribute="color"
                              *ngIf="o.advancePayment > 0"
                              [matTooltip]="'Il y a un acompte de ' + o.advancePayment + '€'"></fa-icon>
                            <span *ngIf="o?.traineeQuantity">
                              <i style="font-weight: 400;">({{o?.traineeQuantity}} x
                                {{o?.fixedPrice}}€) </i></span>
                            {{o?.sessionTotalPrice}}€</span>
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="false">
                      <div class="list_item" *ngIf="!o?.offer?.isLicence">
                        <!-- <div class="list_item"> -->
                        <div class="list_item_offerAddToPayment"
                          style="--numbOfItemInBasket:var(--numbOfItemInBasket){{sessionBooking?.length}}"
                          [style.grid-template-columns]="o?.offer?.hasSession ? 'max-content 1fr' : '1fr' ">


                          <li class="item_offerAddToPayment">
                            <span class="label">{{o?.offer?.offerName}}</span>
                            <!-- <span class="price" *ngIf="!o?.offer?.isComplete"><strong> À perso.</strong></span> -->
                            <div *ngIf="!o?.offer?.hasSession">
                              <span *ngIf="o?.bookedSessionQuantity">
                                <i>({{o?.bookedSessionQuantity}} x
                                  {{o?.offer.fixedPrice}}€) </i></span>
                              <span class="session_price">{{o?.bookedSessionAmount}}€</span>
                            </div>
                            <!-- <span class="session_price" *ngIf="o?.offer?.isComplete && !o?.offer?.hasSession">{{o?.bookedSessionAmount}}€</span> -->
                          </li>
                        </div>

                        <div class="session" *ngIf="o?.offer?.hasSession">

                          <span class="session_label" appChangeColorTheme attribute="color">
                            <fa-icon [icon]="getFaIcon('faCalendarAlt')"></fa-icon>
                            <ng-container *ngIf="o?.offer?.hasSession">
                              {{o?.sessionName}} -
                              {{o?.sessionStartDate | date: "shortDate":'UTC' || ''}}
                            </ng-container>

                          </span>
                          <div>
                            <span *ngIf="o?.bookedSessionQuantity">
                              <i>({{o?.bookedSessionQuantity}} x
                                {{o?.offer.fixedPrice}}€) </i></span>
                            <span class="session_price">{{o?.bookedSessionAmount}}€</span>
                          </div>
                        </div>

                        <!-- <div class="add_licence" *ngIf="licences?.length">
                          <div class="licence_title">
                            <h5>Ajout de licence</h5>
                            <span><strong>x{{licences?.length}}</strong></span>
                          </div>

                          <div class="licence_content">
                            <div class="licence_item" *ngFor="let l of licences">
                              <p>{{l?.offerName}}</p>
                              <span>
                                <strong>{{l.fixedPrice}}€</strong></span>
                            </div>
                          </div>
                        </div> -->
                      </div>
                    </ng-container>
                  </ng-container>

                </ng-container>


                <li *ngIf="updateBasketBooked ? !offerAddToPayment?.length :  !sessionBooking?.length"
                  class="no_offer_to_perso">Aucune offre sélectionnée </li>


                <div class="add_licence" *ngIf="licences?.length">
                  <div class="licence_title">
                    <h5>Ajout de licence</h5>
                    <span><strong>x{{licences?.length}}</strong></span>
                  </div>

                  <div class="licence_content">
                    <div class="licence_item" *ngFor="let l of licences">
                      <p>{{l?.offerName}}</p>
                      <span>
                        <strong>{{l.fixedPrice}}€</strong></span>
                    </div>
                  </div>
                </div>

                <li class="last_item" *ngIf="basketWithPrice?.grandDiscount > 0"><span class="label">Réduction
                    supplémentaire
                  </span> <span class="price"><strong>{{basketWithPrice?.grandDiscount}}%</strong></span></li>
                <li class="last_item" *ngIf="basketWithPrice?.grandDiscount > 0"><span class="label">Total remisé
                  </span>
                  <span class="price"><strong>{{basketWithPrice?.discountedGrandTotal}}€</strong></span>
                </li>
              </ul>
            </ng-container>
          </ng-container>




          <p class="no_offer" *ngIf=" tab !== 'basket' ? !basket?.length : !sessionBooking?.length ">Aucune offre</p>

        </div>

        <div class="total_booking_button">
          <div class="total_basket">
            <div class="last_item "><span class="label">Total panier</span> <span class="price"><strong>{{ tab !==
                  'basket' || updateBasketBooked ? totalPrice: booking?.bookingAmount}}€</strong></span>
            </div>
            <div class="last_item" *ngIf="totalDiscount"><span class="label">Total remisé</span> <span
                class="price"><strong>{{totalDiscount}}€</strong></span></div>
          </div>
          <div class="buttons_action_booking" *ngIf="tab === 'basket' &&  updateBasketBooked">
            <button type="button" (click)="applyCounterBasket()" appChangeColorTheme attribute="bgc">Validation
              Panier</button>
            <button type="button" (click)="openDialogInContruction('Envoie du devis')" appChangeColorTheme
              attribute="bgc">Envoi@gmail devis-facture</button>
          </div>

          <div *ngIf="tab !== 'basket'"
            [ngClass]="{payment_active: allMyOffersIsComplete(), payment_deactive: (!allMyOffersIsComplete() || !offerAddToPayment?.length)}"
            (click)="allMyOffersIsComplete() ? bookOffer(): null ">
            Confirmer la commande

          </div>
        </div>
      </div>

      <div class="payment" *ngIf="tab === 'basket'">
        <div class="sub_title_basket">
          <fa-icon [icon]="getFaIcon('faCreditCard')"></fa-icon>
          <h4>Paiement(s) déjà effectué(s) (<strong>{{paymentRefundList?.paymentRefundList?.length || 0}}</strong>)</h4>
        </div>

        <ul class="payment_list">
          <ngx-simplebar>
            <ng-container *ngFor="let pL of paymentRefundList?.paymentRefundList">
              <ng-container [ngSwitch]="pL.paymentType">
                <li *ngSwitchCase="'online'">Paiement en ligne : <span><strong>{{pL?.amount || 0}}€</strong></span></li>

                <li *ngSwitchDefault>

                  <div class="line">
                    <div class="counter_price">
                      <p> {{pL?.amount > 0? 'Paiement au guichet - ' : 'Remboursement au guichet - '
                        }}<strong>{{pL?.paymentType}}
                          :</strong></p>
                      <span><strong>{{ pL?.amount > 0? (pL?.amount) : (pL?.amount *-1) }}€</strong></span>
                    </div>

                    <div class="counter_date">Éffectué le <strong>{{pL.paymentDate |date: "shortDate":'UTC'}}</strong>
                    </div>
                  </div>
                </li>

              </ng-container>
            </ng-container>
          </ngx-simplebar>
        </ul>

        <div class="total_booking_button">
          <div class="total_basket">
            <div class="last_item ">
              <span class="label">{{ paymentRefundList?.leftToPay >= 0 ? 'Reste à payer' : 'Reste à rembourser'}}</span>
              <span class="price"
                [ngClass]="{green: paymentRefundList?.leftToPay === 0, red: paymentRefundList?.leftToPay > 0 || paymentRefundList?.leftToPay < 0   }"><strong>{{paymentRefundList?.leftToPay
                  || 0}}€</strong></span>
            </div>
          </div>
          <div class="buttons_action_booking">

            <button type="button" (click)="openDialogAddPaymentDefund('Effectuer un remboursement', 'defund')"
              appChangeColorTheme attribute="bgc" [disabled]="booking?.bookingPayedAmount <= 0"
              [style.opacity]="booking?.bookingPayedAmount <= 0 ? .5: 1 ">Remboursement</button>

            <button type="button" (click)="openDialogAddPaymentDefund('Ajouter un paiement', 'payment')"
              appChangeColorTheme attribute="bgc" [disabled]="booking?.bookingAmount == booking?.bookingPayedAmount"
              [style.opacity]="booking?.bookingAmount <= booking?.bookingPayedAmount ? .5: 1">Ajouter un
              paiement</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>